import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentRequest: String,
    controllerPath: String
  }

  connect() {
    let currentPath = this.currentRequestValue;
    let controllerPath = this.controllerPathValue;
    let currentLinkObject = this.getLinkObjectByPath(currentPath, controllerPath);

    if (currentLinkObject) {
      currentLinkObject.classList.add('active')

      this.openTreeViewParents(currentLinkObject)
    }
  }

  getLinkObjectByPath(currentPath, controllerPath) {

    if (controllerPath) {
      let controllerLink = document.querySelector(`a.nav-link[href='${controllerPath}']`);
      if (controllerLink) {
        return controllerLink;
      }
    }

    let exactLink = document.querySelector(`a.nav-link[href$='${currentPath}']`);
    if (exactLink) {
      return exactLink;
    }

    const allLinks = document.querySelectorAll('a.nav-link[href]');
    let bestMatch = null;
    let bestMatchLength = 0;

    for (const link of allLinks) {
      const linkHref = link.getAttribute('href');

      if (currentPath.startsWith(linkHref)) {
        const nextChar = currentPath[linkHref.length];
        if (!nextChar || nextChar === '/') {
          if (linkHref.length > bestMatchLength) {
            bestMatch = link;
            bestMatchLength = linkHref.length;
          }
        }
      }
    }

    return bestMatch;
  }

  getNavTreeParentObject(element) {
    return element.closest('ul.nav-treeview');
  }

  openTreeViewParents(element) {
    let treeviewParentElement = this.getNavTreeParentObject(element);

    if (treeviewParentElement) {
      treeviewParentElement.closest('li.nav-item').classList.add('menu-open')
      this.openTreeViewParents(treeviewParentElement.closest('li.nav-item'))
    }
  }
}
